var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('transaction-form',{attrs:{"loading":_vm.loading,"transactionData":_vm.transaction,"formErrors":_vm.formErrors},on:{"transactionSubmitted":_vm.handleSubmit,"formChanged":() => (_vm.alertLeave = true)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }